import { SxProps, Theme } from "@mui/material/styles";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";

export const useStepperStyles = (): SxProps<Theme> | undefined => {
  const { darkMode } = useDarkModeStore();

  return {
    marginTop: 4,
    marginBottom: 4,
    marginLeft: "20%",
    "& .MuiStepLabel-root": {
      padding: 0,
      height: "15px",
    },
    "& .MuiStepLabel-label": {
      fontSize: 14,
      marginLeft: 2,
      fontWeight: darkMode ? "bold" : "600",
      color: darkMode ? "#C4C4C4" : "var(--color-nav-bar-item)",
    },
    "& .MuiStepLabel-label.Mui-active": {
      color: darkMode ? "#F9F9F9" : "var(--color-pink)",
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: darkMode ? "#F9F9F9" : "var(--color-pink)",
    },
    "& .MuiStepConnector-line": {
      opacity: 0.5,
      borderLeftWidth: 2,
      borderColor: darkMode ? "grey" : "var(--color-pink)",
    },
    "& .Mui-active .MuiStepConnector-line, & .Mui-completed .MuiStepConnector-line":
      {
        opacity: 1,
      },
    "& .Mui-active .MuiStepConnector-line": {
      opacity: 1,
      borderLeftWidth: 2,
      borderColor: darkMode ? "var(--color-pink)" : "var(--color-pink)",
    },
  };
};
